// extracted by mini-css-extract-plugin
export default {"left-panel":"DSIProjects_left-panel__ASLAO","middle-panel":"DSIProjects_middle-panel__Cd9lY"};